import http from "@/axios";
import {GiftCategory, GiftDto, NewGiftsDto, OwnedGiftDto} from "@/store/gift/types";
import PlayerStore from "@/store/player";
import {Balance} from "@/store/player/types";

export default class GiftStore {

    public static getAvailableGifts(giftCategory: GiftCategory): Promise<GiftDto[]> {
        return http.get('/api/gift/shop/' + String(giftCategory) + '/list')
            .then(r => r.data)
            .then(rObj => {
                let res: GiftDto[] = [];
                for (let obj of rObj) {
                    let item = Object.assign(new GiftDto(), obj);
                    res.push(item);
                }

                return res;
            });
    }

    public static getMyGifts(page: number): Promise<OwnedGiftDto[]> {
        return http.get('/api/gift/my/list/' + String(page))
            .then(r => r.data)
            .then(rObj => {
                let res: OwnedGiftDto[] = [];
                for (let obj of rObj) {
                    let item = Object.assign(new OwnedGiftDto(), obj);
                    res.push(item);
                }
                return res;
            });
    }

    public static getPlayerGifts(playerId: number, page: number): Promise<OwnedGiftDto[]> {
        return http.get('/api/gift/' + String(playerId) + '/' + String(page))
            .then(r => r.data)
            .then(rObj => {
                let res: OwnedGiftDto[] = [];
                for (let obj of rObj) {
                    let item = Object.assign(new OwnedGiftDto(), obj);
                    res.push(item);
                }
                return res;
            });
    }

    public static getNewGifts(): Promise<NewGiftsDto> {
        return http.get('/api/gift/my/new')
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new NewGiftsDto(), rObj);
            });
    }

    public static create(giftId: string, text: string, playerId: number,
                         errorCallback: (message: string) => unknown,
                         successCallback: () => unknown): Promise<void> {
        return http.post('/api/gift/create/' + giftId + '/' + String(playerId), text)
            .then(r => r.data)
            .then((balanceObj) => {
                let balance: Balance = Object.assign(new Balance(), balanceObj);
                PlayerStore.SET_BALANCE(balance);
                successCallback();
            }).catch((e: any) => {
                errorCallback(e.response.data.message);
            });
    }

    public static approve(giftId: number): Promise<NewGiftsDto> {
        return http.post('/api/gift/approve/' + giftId)
            .then(r => r.data)
            .then(rObj => {
                let ng: NewGiftsDto = Object.assign(new NewGiftsDto(), rObj);
                PlayerStore.SET_HAVE_NEW_GIFT(ng.count > 0);
                return ng;
            });
    }

    public static approveAll(): Promise<void> {
        return http.post('/api/gift/all/approve').then(() => {
            PlayerStore.SET_HAVE_NEW_GIFT(false);
        });
    }

    public static setTextHidden(giftId: number, hidden: boolean): Promise<void> {
        return http.post('/api/gift/gift/' + String(giftId) + '/set/hidden/' + String(hidden));
    }

    public static delete(giftId: number): Promise<void> {
        return http.post('/api/gift/gift/' + String(giftId) + '/delete');
    }

    public static info(giftId: number): Promise<OwnedGiftDto> {
        return http.get('/api/gift/gift/' + String(giftId) + '/info')
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new OwnedGiftDto(), rObj);
            });
    }

}
